import React, {useState, useEffect} from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import PSRRightSideSU from "./pSRRightSideSU.js";
import Footer from "../../../components/footer/component.js";
import { currentDomain } from "../../../utils/general-config.js";
import { DomainName } from "../../../utils/constants.js";
import { getPortalCD } from "../../../utils/helpers";
import { useNavigate, useParams } from "react-router-dom";
import SecureSimpliLeftSideSection from "../secureSimpli/secureSimpliLeftSideSection";
import SecureSimpliGetStartedModal from "./secureSimpliGetStartedModal";
const PSRSignUP = ({
  onSignIn,
  onSignUp,
  pwdNavigate,
  signUpNavigate,
  disableBtn,
  responseFacebook,
  googleLogin,
  emailError,
  emailErrorMsg,
  passwordError,
  passwordErrorMsg,
  loginError,
  loginErrorMessage,
  onEmailChangeHandler,
  onPwdChangeHandler,
  onPasswordKeyPress,
  emailId,
  pwd,
  privacyPolicy,
  termsOfUse,
  appleLogin,
  isCaptchaVisible,
  handleCaptchaSuccess,
}) => {
  const { t } = useTranslation();
  let Domain = currentDomain().toLowerCase();
  const [showGetStartedModal, setShowGetStartedModal] = useState(true);
  const { locale } = useParams();
  const portalCD = getPortalCD(locale);

  useEffect(() => {
    // Show the modal only for PSSC portal
    if (portalCD !== "PSSC") {
      setShowGetStartedModal(false);
    }
  }, [portalCD]);

  return (
    <>
      <Helmet>
        <meta name="description" content={t("sign_in.ps.description_meta")} />
        <title>{Domain === DomainName.PDFSIMPLI ? t("page_title.ps.sign_up") : t("page_title.ws.sign_up")}</title>
      </Helmet>{" "}
      {portalCD === "PSSC" && showGetStartedModal ? (
        <section className="main-content p-4 bg-rs-modal-gradient !font-rethink md:h-screen mt-6 md:mt-8 lg:mt-10 mb-16 md:mb-8 lg:mb-10">
          <SecureSimpliGetStartedModal
            open={showGetStartedModal}
            setOpen={setShowGetStartedModal}
            privacyPolicy={privacyPolicy}
            termsOfUse={termsOfUse}
          />
        </section>
      ) : (
        <>
          <section className="main-content !min-h-[calc(100vh-9.8rem)] min-[1400px]:!pt-0 backdrop-blur-[100px] bg-blur-bg-rs !font-rethink !pt-[10px] md:pt-[20px]">
            <div className="flex justify-center items-center flex-col">
              <div className="container min-[1000px]:!pb-[1.5rem] min-[1400px]:!pb-0 mx-auto">
                <div className="flex w-full justify-center items-center flex-col md:flex-row gap-x-12">
                  {portalCD === "PSSC" ? (
                    <SecureSimpliLeftSideSection />
                  ) : (
                    <div className="w-full md:w-2/5 order-2 md:order-none lg:max-w-[400px] lg:h-[450px]">
                      <div className="font-bold text-[24px] text-center align-middle flex justify-center max-[550px]:my-[20px] -mt-9 lowercase text-[#16283D]">
                        {t("sign_up.safe_and_secure")}
                      </div>
                      <div className="w-full h-full lg:h-auto flex items-center justify-center">
                        <img
                          src="/app/account/static/images/pdfsimpli-convert.svg"
                          className="w-full h-full lg:h-auto  object-contain"
                        />
                      </div>
                      {Domain === DomainName.PDFSIMPLI && (
                        <>
                          <span className="hidden md:flex items-center justify-center">
                            <img
                              src={process.env.PUBLIC_URL + "/static/images/worksimpli/review-new-icon.svg"}
                              className="block"
                            ></img>
                          </span>
                        </>
                      )}
                    </div>
                  )}

                  <div className="w-full lg:w-2/5  md:w-3/5  min-[1400px]:w-[48.5%] order-1 md:order-2 min-[1400px]:py-[40px] min-[1400px]:px-[60px]">
                    <PSRRightSideSU
                      pwdNavigate={pwdNavigate}
                      signUpNavigate={signUpNavigate}
                      onSignUp={onSignUp}
                      disableBtn={disableBtn}
                      responseFacebook={responseFacebook}
                      googleLogin={googleLogin}
                      passwordError={passwordError}
                      emailError={emailError}
                      passwordErrorMsg={passwordErrorMsg}
                      onEmailChangeHandler={onEmailChangeHandler}
                      emailId={emailId}
                      onPwdChangeHandler={onPwdChangeHandler}
                      onPasswordKeyPress={onPasswordKeyPress}
                      pwd={pwd}
                      appleLogin={appleLogin}
                      termsOfUse={termsOfUse}
                      privacyPolicy={privacyPolicy}
                      loginErrorMessage={loginErrorMessage}
                      emailErrorMsg={emailErrorMsg}
                      loginError={loginError}
                      isCaptchaVisible={isCaptchaVisible}
                      handleCaptchaSuccess={handleCaptchaSuccess}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </>
      )}
    </>
  );
};

export default PSRSignUP;
